import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validarCNPJ(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== '' && control.value !== null) {
      let cnpj = control.value
        .replaceAll('/', '')
        .replaceAll('-', '')
        .replaceAll('.', '');
      if (
        cnpj == '0'.repeat(14) ||
        cnpj == '1'.repeat(14) ||
        cnpj == '2'.repeat(14) ||
        cnpj == '3'.repeat(14) ||
        cnpj == '4'.repeat(14) ||
        cnpj == '5'.repeat(14) ||
        cnpj == '6'.repeat(14) ||
        cnpj == '7'.repeat(14) ||
        cnpj == '8'.repeat(14) ||
        cnpj == '9'.repeat(14)
      ) {
        return { CNPJinvalid: true };
      } else {
        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) return { CNPJinvalid: true };

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(1)) return { CNPJinvalid: true };

        return null;
      }
    } else return null;
  };
}
